import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import resize from '@mailobj-browser/front/js/events/types/resize.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import * as utilities from '#utilities/js/styles.js'
import { elements, modifiers } from '../styles.js'
import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import rendered from '@mailobj-browser/front/js/tree/rendered.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const switchNavigationType = async (nav) => {
  const list = one(`.${elements.nav_list}`, nav)
  const dropdown = one(`.${utilities.modifiers.lightbox.dropdown}`, nav)
  let scrollWidth
  let clientWidth

  if (list && dropdown) {
    await list.classList.add(utilities.modifiers.visibility.hidden)
    await list.classList.remove(utilities.modifiers.display.none)

    scrollWidth = nav.scrollWidth
    clientWidth = nav.clientWidth

    if (scrollWidth > clientWidth) {
      list.classList.add(utilities.modifiers.display.none)
      list.classList.remove(utilities.modifiers.visibility.hidden)
      dropdown.classList.remove(utilities.modifiers.display.none)
    } else {
      list.classList.remove(utilities.modifiers.visibility.hidden)
      list.classList.remove(utilities.modifiers.display.none)
      dropdown.classList.add(utilities.modifiers.display.none)
    }
  }
}

const onResize = object(listener, {
  type: resize,
  once,
  passive,
  async task (
    defaultView
  ) {
    await wait(150)

    const { document } = defaultView

    for (const navigation of all(`.${elements.nav}`, document)) {
      await switchNavigationType(navigation)
    }

    this.listen(defaultView)
  }
})

export default nav => {
  const { ownerDocument } = nav
  const { defaultView } = ownerDocument
  const list = one(`.${elements.nav_list}`, nav)
  const modal = closest(`.${elements.modal}`, nav)

  queueMicrotask(async () => {
    if (modal && !ownerDocument.contains(modal)) {
      await inserted(modal, one(`.${utilities.elements.aside_lightboxes}`, ownerDocument))
    }

    if (nav) {
      if (await rendered(list, nav)) {
        await switchNavigationType(nav)
      }
    }

    onResize.listen(defaultView)
  })
}
